import { render, staticRenderFns } from "./ADrecommendations.vue?vue&type=template&id=535ea8e0"
import script from "./ADrecommendations.vue?vue&type=script&lang=js"
export * from "./ADrecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports